import { render, staticRenderFns } from "./membershipCharge.vue?vue&type=template&id=04a83f34&scoped=true&"
import script from "./membershipCharge.vue?vue&type=script&lang=js&"
export * from "./membershipCharge.vue?vue&type=script&lang=js&"
import style0 from "./membershipCharge.vue?vue&type=style&index=0&id=04a83f34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a83f34",
  null
  
)

export default component.exports